import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {httpDeleteEvent, HttpDeleteEventOptions} from '@/features/agenda/http/agenda.http'

export const useDeleteAgendaEvent = ({
    urlParams,
    params,
    options
}: {
    urlParams: {eventId: string}
    params?: {applyToFutureEvents: boolean}
    options?: Omit<UseMutationOptions<unknown, Error, HttpDeleteEventOptions['payload'] | void, unknown>, 'mutationFn'>
}) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.DELETE_EVENT],
        mutationFn: payload =>
            httpDeleteEvent({
                urlParams,
                payload: payload || undefined,
                params
            }),
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PLANNED_ACCESSES]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT_ACCESS_COUNTERS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_AVAILABILITIES]})
            // Invalidate the whole AGENDA_EVENTS tree (calendar list + per-therapist lists + open event
            // detail + warning banner) so the deleted event disappears from the currently displayed agenda
            // even when the socket events:deleted broadcast does not arrive. The previous 'extended'-only
            // invalidation never matched the calendar list keys.
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.AGENDA_EVENTS]})

            options?.onSuccess?.(data, variables, context)
        }
    })
}
